import { getMarkRange } from '@tiptap/core';
import { TextSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

export const dispatchSelectionByRange = (view: EditorView, from: number, to: number) => {
  const $start = view.state.doc.resolve(from);
  const $end = view.state.doc.resolve(to);
  const transaction = view.state.tr.setSelection(new TextSelection($start, $end));
  view.dispatch(transaction);
};

export const selectLinkByPos = (view: EditorView, pos: number) => {
  const range = getMarkRange(view.state.doc.resolve(pos), view.state.schema.marks.link);
  if (!range) return false;

  dispatchSelectionByRange(view, range.from, range.to);
  return true;
};
